import styled, { css } from 'styled-components';

const warningStyles = css`
  padding: 14px 16px;
  border: 1px solid ${({ theme }) => theme.borders.warningBanner};
  background-color: ${({ theme }) => theme.backgrounds.warningBanner};
  border-radius: 4px;
`;

const noteStyles = css`
  padding: 2px 0 2px 14px;
  border-left: 3px solid ${({ theme }) => theme.borders.workspaceItem};
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  ${({ $warning }) => ($warning ? warningStyles : noteStyles)}
`;

export const Title = styled.strong`
  font-size: 13.5px;
  font-weight: 600;
  color: ${({ theme }) => theme.text.actionBar};
`;

export const Text = styled.div`
  font-size: 13.5px;
  line-height: 1.55;
  color: ${({ theme }) => theme.text.workspaceItem};
`;
